import { County, Workplace, WorkplaceJob } from '../api/app-types/workplace.app';

export const mockCounties: County[] = [
	{
		initial: 'KOE',
		specialistIntegrationService: 'Köln Integration Service',
		remark: 'Köln District',
		display: 'Köln',
	},
	{
		initial: 'DUS',
		specialistIntegrationService: 'Düsseldorf Integration Service',
		remark: 'Düsseldorf District',
		display: 'Düsseldorf',
	},
	{
		initial: 'ESS',
		specialistIntegrationService: 'Essen Integration Service',
		remark: 'Essen District',
		display: 'Essen',
	},
];

export const mockWorkplace: Workplace = {
	id: 4321,
	name: 'PlanB. Workplace Hüttlingen',
	cityDistrict: {
		initial: 'AAAA',
		specialistIntegrationService: 'BBBB',
		remark: 'CCCCC',
		display: 'DDDD',
	},
	address: {
		streetAndHouseNumber: 'Kocherstraße 15',
		postalCodeAndCity: '12311 Hüttlingen',
		anonym: '',
		id: 15,
		identifier: '',
		soundexStreet: '',
	},
	workplacesJobs: undefined,
	contactPoints: [
		{
			id: 1,
			personId: 4321,
			personTypeId: 13,
			preferredWayOfContact: true,
			categoryContactPointId: 2,
			contactValue: 'plan-b@example.com',
		},
		{
			id: 2,
			personId: 4321,
			personTypeId: 13,
			preferredWayOfContact: false,
			categoryContactPointId: 1,
			contactValue: '+49 123 4567',
		},
	],
	institutionPersons: [],
	industryName: 'MockBranch',
	isMainInstitution: false,
};

export const mockWorkplace2: Workplace = {
	id: 8765,
	name: 'PlanA. Workplace Hüttlingen',
	cityDistrict: {
		initial: 'AAAA',
		specialistIntegrationService: 'BBBB',
		remark: 'CCCCC',
		display: 'DDDD',
	},
	address: {
		streetAndHouseNumber: 'Kocherstraße 15',
		postalCodeAndCity: '12311 Hüttlingen',
		anonym: '',
		id: 15,
		identifier: '',
		soundexStreet: '',
	},
	workplacesJobs: undefined,
	contactPoints: [],
	institutionPersons: [],
	industryName: '',
	isMainInstitution: false,
};

export const mockWorkplaces: Workplace[] = [mockWorkplace, mockWorkplace2];

export const mockWorkplaceJobs: WorkplaceJob[] = [
	{
		id: 1,
		createdAt: new Date(),
		institutionInformed: true,
		isActive: true,
		occupationTitle: 'Softwareentwickler',
		remark: 'Arbeitet an verschiedenen Projekten',
		typeAndScopeOfTheWorkplace: 'Vollzeit',
	},
	{
		id: 2,
		createdAt: new Date(),
		institutionInformed: false,
		isActive: true,
		occupationTitle: 'Systemadministrator',
		remark: 'Verantwortlich für die IT-Infrastruktur',
		typeAndScopeOfTheWorkplace: 'Teilzeit',
	},
];
